export default __webpack_public_path__ + "static/media/3.c2164237.png";